import React from "react";
import {
  SideNavItem as SideNavItemStyle,
  ImageContainer,
  ContentContainer,
} from "./style";

const SideNavItem = (props) => (
  <SideNavItemStyle {...props}>
    <ImageContainer>
      <img src={props.icon} alt="profile-image" />
    </ImageContainer>
    <ContentContainer>
      <p>{props.name}</p>
      {props.message}
    </ContentContainer>
  </SideNavItemStyle>
);

export default SideNavItem;
